import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMijnHuishouden = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <mask
      id="MijnHuishouden_svg__a"
      width={13}
      height={26}
      x={20}
      y={8}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M20.85 14c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6m0 12v8h12v-8c0-3.31-2.69-6-6-6s-6 2.69-6 6"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#MijnHuishouden_svg__a)">
      <path
        fill="#55468D"
        d="m25.18 39.32 7.07-12.25L20 20z"
      />
      <path
        fill="#31287C"
        d="m20 20-7.07 12.25 12.25 7.07z"
      />
      <path
        fill="#55468D"
        d="m39.32 14.82-7.07 12.25 12.24 7.07zM39.32 14.82 27.07 7.75 20 20zM5.86 44.49l19.32-5.17-12.25-7.07z"
      />
      <path
        fill="#55468D"
        d="m20 20 12.25 7.07 7.07-12.25z"
      />
      <path
        fill="#31287C"
        d="m44.49 34.14-12.24-7.07-7.07 12.25z"
      />
      <path
        fill="#55468D"
        d="m20 20 7.07-12.25L14.82.68zM34.14-4.49 27.07 7.75l12.25 7.07z"
      />
    </g>
    <mask
      id="MijnHuishouden_svg__b"
      width={13}
      height={28}
      x={7}
      y={6}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M7.15 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6m0 12v10h12V24c0-3.31-2.69-6-6-6s-6 2.69-6 6"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#MijnHuishouden_svg__b)">
      <path
        fill="#55468D"
        d="m-4.49 5.86 12.24 7.07L14.82.68z"
      />
      <path
        fill="#7D6EA5"
        d="M7.75 12.93.68 25.18 20 20z"
      />
      <path
        fill="#55468D"
        d="m5.86 44.49 7.07-12.24L.68 25.18z"
      />
      <path
        fill="#7D6EA5"
        d="m20 20-7.07 12.25 12.25 7.07zM34.14-4.49 14.82.68l12.25 7.07z"
      />
      <path
        fill="#55468D"
        d="M-4.49 5.86.68 25.18l7.07-12.25z"
      />
      <path
        fill="#7D6EA5"
        d="m5.86 44.49 19.32-5.17-12.25-7.07zM.68 25.18l12.25 7.07L20 20zM20 20l7.07-12.25L14.82.68zM14.82.68 7.75 12.93 20 20z"
      />
    </g>
    <path
      fill="#fff"
      d="M13.15 17.02A4.02 4.02 0 0 1 9.13 13h1c0 1.67 1.35 3.02 3.02 3.02s3.02-1.35 3.02-3.02h1c0 2.22-1.8 4.02-4.02 4.02"
    />
    <mask
      id="MijnHuishouden_svg__c"
      width={13}
      height={12}
      x={20}
      y={8}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M26.85 20a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
      />
    </mask>
    <g mask="url(#MijnHuishouden_svg__c)">
      <path
        fill="#fff"
        d="M24.63 19.02A4.02 4.02 0 0 1 20.61 15h1c0 1.67 1.35 3.02 3.02 3.02s3.02-1.35 3.02-3.02h1c0 2.22-1.8 4.02-4.02 4.02"
      />
    </g>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMijnHuishouden);

export default ForwardRef;
